<template>
  <div id="app">
    <!-- Navigation -->
    <!-- Header -->
    <header class="masthead">
      <div class="container">
        <div class="front-flex">
          <div class="intro-text">
            <div class="intro-lead-in">
              Tech your business<br />
              & social solutions <br />
              with <span class = "rubicon">
              XRubicon.
            </span>
            </div>
            
            <div class="intro">Creating smart cities</div>
                <router-link :to="{ name: 'Contact' }">

         <a class="btn btn-new btn-xl js-scroll-trigger" href="#services"
                style = "background-color: #A31B1F ; color : #FFFFFF"
                
                >Learn more</a
              > 
                      </router-link>
        
          </div>
          <div class="img-front intro-text">
            <img src="../../img/ar.png" />
          </div>
        </div>
      </div>
    </header>
  

    <!-- Services -->
    <section id="services">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center">
          
          </div>
        </div>
        <div class="row text-center">
          <div class="col-md-4 col-sm-6">
            <img src="../assets/img/Software.png" height = "210px"/>
            <h4 class="service-heading">Software Development</h4>
            <p class="text-mu">
              We bring to desk real life solving software development
              applications.
            </p>
          </div>
          <div class="col-md-4 col-sm-6">
            <img src="../assets/img/Business.png" height = "210px" />
            <h4 class="service-heading">Business Development</h4>
            <p class="text-mu">
              We provide quality assurance growth for business organizations and
              models.
            </p>
          </div>
          <div class="col-md-4 col-sm-6">
            <img src="../assets/img/Social.png" height="210px" />
            <h4 class="service-heading">Social Enterprise Development</h4>
            <p class="text-mu">
              This is what we are made for, we provide top notch social
              enterprise solutions.
            </p>
          </div>
        </div>
      </div>
    </section>


        <Portfolio></Portfolio>


    <!-- Platform -->
    <section id="platform">
      <div class="container">
        <div class="middle-flex">
          <div class="middle-text">
            <div class="middle-lead-in">
              Provide growth platform for both individual and corporate social
              enterprises<br /><br />
                  <router-link :to="{ name: 'Contact' }">

         <a class="btn btn-new btn-xl js-scroll-trigger" href="#services"
                style = "background-color: #A31B1F ; color : #FFFFFF"
                
                >Learn more</a
              > 
                      </router-link>
        
            </div>
            <div class="img-front middle-text">
              <img src="../../img/career_.png" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Portfolio from "../components/Portfolio";

export default {
  name: "app",
  components: {
    Portfolio
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100vw;
  overflow-x: hidden;
}
.text-mu{
  color: #000 !important
}
p{
  color: #A19DAF
}
body {
  background: black;
}
</style>